module.exports = __webpack_public_path__ + "static/img/SanFranciscoDisplayThin.3e37b4d.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/SanFranciscoDisplayThin.svg
// module id = RdNh
// module chunks = 1